<template>
  <div>
    <!------------------
            HEADER
    -------------------->
    <div class="bg-white p-3 pl-4 page-header" ref="pageHeader" style="padding-bottom: 0">
      <div class="row d-flex align-items-top" style="max-width: 1000px">
        <div class="col">
          <div>
            <h4>
              <svg
                width="24"
                height="24"
                fill="currentColor"
                class="bi-file-earmark me-2 b-icon bi"
                viewBox="0 0 16 16"
                version="1.1"
                id="svg4"
              >
                <path
                  d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"
                  id="path2"
                />
                <path
                  d="m 5.1218042,10.781435 h 0.7648806 c 0.2424881,2.088851 1.6218635,3.295535 3.7970601,3.295535 0.4475591,0 0.8397131,-0.04893 1.1937321,-0.133116 V 13.00844 c -0.348262,0.08563 -0.75193,0.122323 -1.1937321,0.122323 -1.5110531,0 -2.4860418,-0.862019 -2.7162975,-2.348608 H 9.8578749 V 10.114413 H 6.9185181 V 9.4409161 c 0,-0.07915 0,-0.1575811 0.00576,-0.2367316 H 9.8585939 V 8.5371627 H 7.0055835 C 7.2847685,7.1714586 8.242488,6.3893088 9.6844639,6.3893088 c 0.4418031,0 0.8454701,0.035977 1.1937321,0.1273602 V 5.5819749 A 4.7612557,4.7612557 0 0 0 9.6844639,5.4423824 c -2.1068389,0 -3.4682256,1.1289724 -3.7733144,3.0940606 H 5.1218042 V 9.2041845 H 5.8485487 V 10.114413 H 5.1218042 v 0.667742 z"
                  id="path2-4"
                />
              </svg>
              {{ order.Ordinal + ' ' + order.DisplayName }}
            </h4>
            <div class="text-uppercase text-secondary">
              <small>BELEGE VERWALTEN</small>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="form-inline">
            <!---------------------------------
            HEADER ACTION BUTTONS
        ---------------------------------->
            <b-button
              size="sm"
              variant="light"
              class="mr-2"
              @click="$router.push({ name: 'Beleg erfassen', params: { order } })"
              v-if="$root.$user.isPlaner || $root.$user.isAdmin"
            >
              <b-icon icon="plus" variant="dark" class="mr-1"></b-icon>
              Beleg
            </b-button>
            <b-button size="sm" variant="light" @click="openOrder" title="Auftrag öffnen">
              <b-icon icon="file-earmark" variant="dark"></b-icon>
              Auftrag
            </b-button>

            <b-button class="ml-2 py-0" variant="light" @click="$router.push('/invoices')" size="sm">
              <b-icon icon="x" variant="dark" class="" style="height: 24px; width: 24px;padding-top:3px;"></b-icon>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6" ref="budgetSummarySection">
      <div class="row pt-3 pb-0" style="max-width: 1000px">
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Gesamtbudget</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(parseFloat(order.BudgetSaldo), SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Nachtragsrückstellung</small></label>
          <div class="bg-light p-1">
            {{ $utils.numberWithMaxFrictionsDE(order.NTR, 1) }}
            %
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>&nbsp;</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(
                parseFloat(order.BudgetSaldo) - (parseFloat(order.BudgetSaldo) * order.NTR) / 100,
                SettingsStore
              )
            }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Status</small></label>
          <div class="bg-light p-1">{{ order.ProcessStatus }}</div>
        </div>
      </div>
      <div class="row mt-0 pb-4" style="max-width: 1000px">
        <div class="col col-3" v-show="SettingsStore.settings['KGR_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Kostengruppe</small></label>
          <div class="bg-light p-1">
            {{ order.KGR ? (order.KGR == '' ? '(leer)' : order.KGR) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['Responsible_Selections_Active'] == 'true'">
          <label class="text-muted d-block mb-1"><small>Verantwortlich</small></label>
          <div class="bg-light p-1">
            {{ order.Responsible ? (order.Responsible == '' ? '(leer)' : order.Responsible) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA1_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA1'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA1 ? (order.FA1 == '' ? '(leer)' : order.FA1) : '(leer)' }}
          </div>
        </div>
        <div class="col col-3" v-show="SettingsStore.settings['FA2_Active'] == 'true'">
          <label class="text-muted d-block mb-1">
            <small>{{ SettingsStore.settings['FA2'] }}</small>
          </label>
          <div class="bg-light p-1">
            {{ order.FA2 ? (order.FA2 == '' ? '(leer)' : order.FA2) : '(leer)' }}
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white px-4 mt-0 pt-0" style="border-bottom: 1px solid #dee2e6">
      <div class="row pt-3 pb-0" style="max-width: 1000px">
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Auftragnehmer</small></label>
          <div class="bg-light p-1">
            {{ order.SupplierText }}
          </div>
        </div>
        <div class="col-6">
          <label class="text-muted d-block mb-1"><small>Auftragsstatus / Datum</small></label>
          <div class="bg-light p-1">
            {{ computeOrderStatus(order) }}
          </div>
        </div>
        <div class="col-3">
          <label class="text-muted d-block mb-1"><small>Freistellungsbescheinigung gültig bis</small></label>
          <div class="bg-light p-1">
            {{ order.FreistellungDatum ? $utils.SQLDateToGermanDate(order.FreistellungDatum) : '(leer)' }}
          </div>
        </div>
      </div>
      <div class="row mt-0" style="max-width: 1000px">
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
          <div class="bg-light p-1">
            {{
              $utils.formatCurrency(parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered), SettingsStore)
            }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Hauptauftrag</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.Amount, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>Nachträge</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.AmountAddendumOrdered, SettingsStore) }}
          </div>
        </div>
        <div class="col">
          <label class="text-muted d-block mb-1"><small>SEB Vertragserfüllung</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.SEBAccumulated, SettingsStore) }}
          </div>
        </div>
      </div>
      <div class="row mt-0 pb-4" style="max-width:1000px">
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Abgerechnet</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(parseFloat(order.Invoiced), SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Obligo</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.ObligoAmount, SettingsStore) }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>Schlussgerechnet</small></label>
          <div class="bg-light p-1">
            {{ order.HasFinalInvoice && order.HasFinalInvoice > 0 ? 'Ja' : 'Nein' }}
          </div>
        </div>
        <div class="col col-3">
          <label class="text-muted d-block mb-1"><small>SEB Mängelhaftung</small></label>
          <div class="bg-light p-1">
            {{ $utils.formatCurrency(order.SFMAccumulated, SettingsStore) }}
          </div>
        </div>
      </div>
    </div>
    <div class="main-canvas">
      <div
        class="table-wrapper shadow-muted-super mt-3"
        style="overflow-y: hidden;"
        :style="{ 'max-height': tableHeight }"
      >
        <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
          <b-table
            :items="records"
            :fields="visibleFields"
            ref="theTable"
            v-resizable-columns="{
              fields: visibleFields,
              storageKey: 'invoicedetaillist',
              flexLast: false,
              minWidth: 0
            }"
            class="bg-white sum-header mb-0"
            hover
            head-variant="light"
            show-empty
            small
            @row-clicked="item => $router.push('/invoices/' + $route.params.id + '/' + item.DbId)"
            tbody-tr-class="action-button"
            no-border-collapse
            :sticky-header="tableHeight"
          >
            <template #head(checked)>
              <b-form-checkbox
                class="ml-2"
                :disabled="records.length == 0"
                v-model="checkedAllTableEntries"
                @change="onCheckAllTableEntries"
              ></b-form-checkbox>
            </template>
            <template #head(actions)="data">
              {{ data.label }}

              <span>
                <b-icon
                  icon="three-dots-vertical"
                  v-b-modal.column-selector-invoices-modal
                  class="float-right no-outline"
                  style="margin-top:4px; "
                />
              </span>
              <b-modal
                cancel-disabled
                ok-disabled
                hide-footer
                hide-backdrop
                hide-header
                no-fade
                id="column-selector-invoices-modal"
                body-class="p-0"
                content-class="border-0"
              >
                <b-list-group>
                  <b-list-group-item v-for="item in fields.filter(x => x.hideable == true)" :key="item.key" class="p-2">
                    <b-form-checkbox
                      @change="onClickColumnVisible(item)"
                      v-model="item.visible"
                      value="true"
                      unchecked-value="false"
                    >
                      {{ item.label }}
                    </b-form-checkbox>
                  </b-list-group-item>
                </b-list-group>
              </b-modal>
            </template>
            <template #cell(checked)="data">
              <b-form-checkbox
                class="ml-2"
                @change="onRowChecked(data.item)"
                v-model="data.item.checked"
                :disabled="data.item.editMode"
              ></b-form-checkbox>
            </template>

            <template #cell(AmountCheckedType)="data">
              <b-icon :icon="data.item.AmountCheckedType == 'K' ? 'chevron-contract' : 'chevron-up'" />
            </template>
            <template #cell(actions)="data">
              <div style="width:110px">
                <b-icon
                  class="action-button text-grey"
                  style="width: 18px; height: 18px"
                  icon="arrow-right"
                  title="Beleg öffnen"
                  @click.stop="navigateTo(data.item)"
                />
                <b-icon
                  class="action-button text-grey ml-2"
                  style="width: 18px; height: 18px"
                  icon="bookmarks"
                  title="Rechnungsbegleitblatt öffnen"
                  @click.stop="openInvoiceSheet(data.item)"
                />

                <b-icon
                  icon="trash"
                  variant="grey"
                  class="action-button ml-2"
                  style="width: 16px; height: 16px"
                  title="Beleg löschen"
                  v-show="records.find(x => x.Index > data.item.Index) == null"
                  @click.stop="deleteRecord(data.item)"
                  v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                />
                <!-- totes icon, um dem user ein deaktiviertes icon darzustellen -->
                <b-icon
                  icon="trash"
                  variant="grey"
                  class="ml-2"
                  style="width: 16px; height: 16px; cursor: not-allowed; color: #ddd"
                  title="Nur der letzte Beleg darf gelöscht werden."
                  v-show="records.find(x => x.Index > data.item.Index) != null"
                  @click.stop="records.find(x => x.Index > data.item.Index)"
                  v-if="$root.$user.isPlaner || $root.$user.isAdmin"
                />
              </div>
            </template>
            <template #cell(Status)="data">
              <b-badge
                pill
                class="sr-kennzeichen py-0 px-1"
                v-if="data.item.Status == 2"
                variant="primary"
                style="font-size:100%; "
              >
                <b-icon class="p-0" icon="check-2" variant="white" />
              </b-badge>
            </template>
          </b-table>
        </b-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import InvoicesService from '@/service/InvoicesService.js';
import OrdersService from '@/service/OrdersService.js';
import SettingsStore from '@/store/Settings';
export default {
  data() {
    return {
      AppState,
      SettingsStore,
      isLoading: false,
      records: [],
      order: {},
      tableHeight: '420px',
      checkedAllTableEntries: false,
      selectedRows: [],
      fields: [
        {
          hideable: false,
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index: 1002;'
        },
        {
          hideable: false,
          visible: true,
          key: 'Index',
          label: 'ZF-Nr.',
          thClass: 'align-top',
          tdClass: '',
          sortable: true
        },
        {
          hideable: false,
          visible: true,
          key: 'RNumber',
          label: 'Rg.Nr.',
          thClass: 'align-top ',
          tdClass: '',
          sortable: true
        },
        {
          visible: true,
          hideable: false,
          key: 'RDate',
          label: 'Rg.Datum',
          thClass: 'align-top ',
          sortable: true,
          formatter: x => (x = this.$utils.SQLDateToGermanDate(x))
        },

        {
          hideable: false,
          visible: true,
          key: 'Type',
          label: 'Art',
          thClass: 'align-top ',
          tdClass: '',
          sortable: true,
          formatter: x => (x = this.AppState.invoiceTypes.find(y => y.DbId == x).Abbreviation)
        },
        {
          visible: true,
          hideable: false,
          key: 'AmountCheckedType',
          label: '',
          thClass: 'align-top ',
          sortable: true
        },

        {
          visible: true,
          hideable: true,
          key: 'Amount',
          label: 'Rg. ungeprüft netto',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:120px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'CreatedDate',
          label: 'Erfassungs-datum',
          thClass: 'align-top',
          thStyle: 'min-width:100px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },
        {
          visible: true,
          hideable: true,
          key: 'AmountChecked',
          label: 'Rg. geprüft netto',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'Status',
          label: '',
          thClass: 'align-top ',
          sortable: true
        },
        {
          visible: true,
          hideable: true,
          key: 'CheckedDate',
          label: 'Geprüft am',
          thClass: 'align-top',
          thStyle: 'min-width:100px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },
        {
          visible: true,
          hideable: true,
          key: 'LZWAmountChecked',
          label: 'Leistungs-zuwachs',
          thClass: 'align-top text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'LZWAccumulatedChecked',
          label: 'Leistungs-stand',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMAmount',
          label: 'EGMin mVK geprüft',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMZWAmount',
          label: 'EGMin mVK Zuwachs',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMAcc',
          label: 'EGMin mVK kumuliert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SEBAmount',
          label: 'SEB VE geprüft',
          thClass: 'align-top  text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SEBZWAmount',
          label: 'SEB VE Zuwachs',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SEBAcc',
          label: 'SEB VE kumuliert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'GAAmount',
          label: 'Gesamtanspruch netto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'UStChecked',
          label: 'USt.-\nSatz',
          thClass: 'align-top text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          tdClass: 'text-right',
          sortable: true
        },
        {
          visible: true,
          hideable: true,
          key: 'GAUStAmount',
          label: 'GA USt.-Wert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'GABrutto',
          label: 'Gesamtanspruch brutto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZAAmount',
          label: 'Zahl.anspruch netto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },

        {
          visible: true,
          hideable: true,
          key: 'ZAUStAmount',
          label: 'ZA USt.-Wert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZABrutto',
          label: '(Zahl.anspruch\nbrutto o UStA.)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:130px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'UStAusgleich',
          label: 'USt-\nAusgleich',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZAUStAmountSum',
          label: '(Summe\n32_ZA_UStWert)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZAUStAmountIncl',
          label: '(ZA_UStWert\nInklAusgleich)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },

        {
          visible: true,
          hideable: true,
          key: 'ZABruttoIncl',
          label: '(Zahl.Anspruch\nbrutto m USt.A.)',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:140px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'ZABruttoMaßgeblich',
          label: 'Zahl.Anspruch\nbrutto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMOAmount',
          label: 'EGMin oVK Zuwachs',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'EGMOAmountAccumulated',
          label: 'EGMin oVK kumuliert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        /*
        {
          visible: true,
          hideable: true,
          key: 'MSicherVon',
          label: 'Netto/Brutto Auftragssumme',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true
        },*/
        {
          visible: true,
          hideable: true,
          key: 'SFMPercent',
          label: 'SEB MH\nSatz',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:80px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.numberWithMaxFrictionsDE(x, 1))
        },
        {
          visible: true,
          hideable: true,
          key: 'SFMBasisAmount',
          label: 'SEB MH Basiswert',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },

        {
          visible: true,
          hideable: true,
          key: 'SFMMHAmount',
          label: 'SEB MH',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SFMMHDeltaAmount',
          label: 'SEB MH Veränderung',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'AZAmount',
          label: 'Auszahlung brutto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: normal;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'SkontoProzent',
          label: 'Skonto-\nSatz',
          thClass: 'align-top text-right',
          thStyle: 'min-width:80px;white-space: pre-line;',
          tdClass: 'text-right',
          sortable: true,
          formatter: x => (x = this.$utils.numberWithMaxFrictionsDE(x, 1))
        },
        {
          visible: true,
          hideable: true,
          key: 'SkontoAmount',
          label: 'Skonto-\nBetrag',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          visible: true,
          hideable: true,
          key: 'AZNachSkonto',
          label: 'Zahlbetrag nach Skonto',
          thClass: 'align-top  text-right',
          tdClass: 'text-right',
          thStyle: 'min-width:110px;white-space: pre-line;',
          sortable: true,
          formatter: x => (x = this.$utils.formatCurrency(x, SettingsStore))
        },
        {
          hideable: false,
          visible: true,
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'sticky-col last-col text-center align-middle',
          thClass: 'sticky-col last-col align-top noselect',
          thStyle: 'z-index: 1002;'
        }
      ]
    };
  },
  activated() {
    AppState.loadVisibleFields('invoiceDetailList', this.fields);
    window.addEventListener('resize', this.onWindowResize); // listen for windows size changes, to re-compute height of controls
    this.loadRecords();
    this.loadOrder();
  },
  deactivated() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  methods: {
    loadRecords() {
      this.isLoading = true;
      OrdersService.getInvoicesByOrderId(this.$route.params.id)
        .then(records => {
          this.records = records;
        })
        .catch(err => console.log(err))
        .finally(() => {
          this.onWindowResize();
          this.isLoading = false;
        });
    },
    async loadOrder() {
      OrdersService.getById(this.$route.params.id)
        .then(order => {
          this.order = order;

          if (!this.order.NTR) {
            this.order.NTR = parseFloat(SettingsStore.settings['Nachtragsprozent']).toFixed(2);
          }
        })
        .catch(err => {
          if (err.response) this.$showError(this, err.response.data.error);
          else this.$showError(this, err.toString());
        })
        .finally(async () => {
          await this.$forceUpdate();
          AppState.isLoading = false;
        });
    },
    deleteRecord(item) {
      var questionText = `Soll die Rechnung wirklich gelöscht werden?`;

      const messageVNode = this.$createElement('div', { domProps: { innerHTML: questionText } });
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Rechnung löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            this.isLoading = true;
            InvoicesService.delete(item)
              .then(() => {
                this.order.Invoiced -= item.Amount;
                this.$utils.deleteItemFromArray(this.records, x => x.DbId == item.DbId);
                this.$showSuccess(this, 'Rechnung löschen', 'Rechnung erfolgreich gelöscht');
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data);
                else this.$showError(this, err.toString());
              })
              .finally(() => {
                this.loadRecords();
                this.loadOrder();
                this.isLoading = false;
              });
          }
        });
    },
    navigateTo(item) {
      this.$router.push({ name: 'Rechnungsdetails', params: { id: item.OrderId, iid: item.DbId, order: this.order } });
      //this.$router.push({ path: '/invoices/' + item.OrderId + '/' + item.DbId, params: { order: this.order } });
    },
    openInvoiceSheet(item) {
      const routeData = this.$router.resolve({
        name: 'Rechnungsbegleitblatt',
        params: { id: item.OrderId, iid: item.DbId },
        query: { nav: 'false' }
      });
      window.open(routeData.href, '_blank');

      //window.open(routeData.href, '_blank');
    },

    onCheckAllTableEntries() {
      this.records = this.records.map(item => {
        item.checked = this.checkedAllTableEntries;
        return item;
      });
      this.onRowChecked();
    },
    onRowChecked() {
      this.selectedRows = this.records.filter(x => x.checked);
      this.checkedAllTableEntries = this.records.length > 0 && this.selectedRows.length == this.records.length;
    },
    onClickColumnVisible() {
      AppState.updateVisibleFields('invoiceDetailList', this.fields);
    },
    onWindowResize() {
      setTimeout(() => {
        const totalHeight = window.innerHeight;
        const budgetSummarySection = this.$refs.budgetSummarySection;
        //const headerHeight = this.$refs.pageHeader.offsetHeight;
        const tableHeight = totalHeight - budgetSummarySection.offsetHeight - 365;
        this.tableHeight = tableHeight + 'px';
      }, 300);
    },
    computeOrderStatus(item) {
      if (item.veSection && item.veSection == 'A') {
        return (
          (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
        );
      } else if (item.veSection && item.veSection == 'B') {
        return (
          (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.OrderDate)
        );
      } else return '';
    },
    openOrder() {
      //this.$router.push('/orders/' + this.$route.params.id + '/view');
      this.$router.push('/orders/' + this.$route.params.id + '/addendums');
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible == true || field.visible == 'true');
    }
  }
};
</script>

<style>
.table-wrapper {
  overflow: auto;
  white-space: nowrap;
  border: 1px solid #dee2e6;
}
.table-wrapper .first-col {
  left: 0;
}

.table-wrapper .second-col {
  left: 40px;
}

.table-wrapper .third-col {
  width: 220px;
  min-width: 220px;
  max-width: 220px;
  left: 150px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.table-wrapper .last-col {
  width: 120px;
  min-width: 120px;
  max-width: 120px;
  right: 0;
}
.table-wrapper tbody tr:last-child td {
  border-bottom: 1px solid var(--bauvisor-border);
}
.table-wrapper tbody tr td.sticky-col {
  background-color: var(--bauvisor-primary-light) !important;
}
.table-wrapper .table-striped tbody tr:nth-of-type(odd) td.sticky-col {
  background-color: #efefef !important;
}
.table-wrapper .table-striped tbody tr:nth-of-type(even) td.sticky-col {
  background-color: #f5f5f5 !important;
}
.table-wrapper td:not(:last-child) {
  border-right: 1px solid #dee2e6;
}
.table-wrapper td:last-child {
  border-left: 1px solid #ced2d6;
}
.table-wrapper td:nth-last-child(2) {
  border-left: none;
  border-right: none;
}
.table-wrapper .table.b-table > tbody > .table-active,
.table-wrapper .table.b-table > tbody > .table-active > th,
.table-wrapper .table.b-table > tbody > .table-active > td {
  background-color: #f5f5f5;
}
#column-selector-invoices-modal > .modal-dialog {
  position: absolute;
  top: 500px;
  right: 13px;
}
.sr-kennzeichen {
  display: inline;
  vertical-align: middle;
  border-radius: 4px;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
